import React, { useState, useEffect } from "react";
import FeedbacksContext from "./FeedbacksContext";
import fireBaseApp from '../Firebase';
import { getFirestore, collection, getDocs, addDoc, updateDoc, doc } from "firebase/firestore";

const db = getFirestore(fireBaseApp);

export default function FeedbacksProvider(props) {
    const [feedbacks, setFeedbacks] = useState([]);
    const [feedbacksLoaded, setFeedbacksLoaded] = useState(false);

    const getFeedbacks = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, "feedbacks"));
            const feedbacksList = [];
            querySnapshot.forEach((doc) => {
                feedbacksList.push({
                    id: doc.id,
                    feedback: doc.data().feedback,
                    feedbackName: doc.data().feedbackName,
                    show: doc.data().show,
                })
            });
            setFeedbacks(feedbacksList)
        } catch (e) {
            console.error(e);
        } finally {
            setFeedbacksLoaded(true);
        }
    }

    // Throws on failure so the form can tell the visitor.
    const addFeedback = async (values) => {
        await addDoc(collection(db, "feedbacks"), values);
        setFeedbacks((current) => [...current, values]);
    };

    const updateFeedback = (newFeedback) => {
        const ref = doc(db, "feedbacks", newFeedback.id);
        updateDoc(ref, {
            show: newFeedback.show
        });
    }

    useEffect(() => {
        getFeedbacks();
    }, [])

    return (
        <FeedbacksContext.Provider
            value={{ feedbacks, feedbacksLoaded, addFeedback, updateFeedback }}
        >
            {props.children}
        </FeedbacksContext.Provider>
    );
}